module.exports = __webpack_public_path__ + "promo/app-store-badges/apple-app-store-en-c8e5fb344eda9b3d3c707b5aadc1ecf0.svg";


//////////////////
// WEBPACK FOOTER
// ./images/promo/app-store-badges/apple-app-store-en.svg
// module id = oLht
// module chunks = 24